import React from 'react';
import { useTranslation } from 'react-i18next'; // Import useTranslation
import cn from 'classnames';
import style from "../common.module.scss"
import ScalesIcon from '../../../shared/icons/ScalesIcon';
import BoxIcon from '../../../shared/icons/BoxIcon';
import TemperatureIcon from '../../../shared/icons/TemperatureIcon';
import { getTransportTypeIcon } from '../../../../mock';
import { getVehicleTypeName } from "../../../../utils/getVehicleTypeName";
import DocumentIconNew from '../../../shared/icons/DocumentIconNew';
import ConfectioneryIcon from '../../../shared/icons/ConfectioneryIcon';
import FurnitureIcon from '../../../shared/icons/FurnitureIcon';
import MetalIcon from '../../../shared/icons/MetalIcon';
import MetalCansIcon from '../../../shared/icons/MetalCansIcon';
import BeveragesIcon from '../../../shared/icons/BeveragesIcon';
import EquipmentIcon from '../../../shared/icons/EquipmentIcon';
import FoodIcon from '../../../shared/icons/FoodIcon';
import GlassProductsIcon from '../../../shared/icons/GlassProductsIcon';
import ConstructionMaterialsIcon from '../../../shared/icons/ConstructionMaterialsIcon';
import TobaccoIcon from '../../../shared/icons/TobaccoIcon';
import PharmaceuticalsIcon from '../../../shared/icons/PharmaceuticalsIcon';
import FertilizeIcon from '../../../shared/icons/FertilizeIcon';
import AlcoholIcon from '../../../shared/icons/AlcoholIcon';
import CommentIcon from "../../../shared/icons/CommentIcon";
import PalletIcon from '../../../shared/icons/PalletIcon';
import BarcodeIcon from '../../../shared/icons/BarcodeIcon';
import PolicyIcon from '../../../shared/icons/PolicyIcon';
import WagonTypeIcon from "../../../shared/icons/WagonTypeIcon";
import CargoWagonNumbers from "./CargoWagonNumbers";
import EtsngCodeIcon from "../../../shared/icons/EtsngCodeIcon";
import GngCodeIcon from "../../../shared/icons/GngCodeIcon";
import { isRailwayOrder } from "../../../../pages/orders/utils/railwayOrder";

const OrdersInfoCargo = ({ item, order, isDetails = true, tnvedCode = null }) => {
    const { t } = useTranslation(); // Initialize t function
    const isRailway = isRailwayOrder(order);

    const renderVehicleIcon = (vehicleType) => {
        const IconComponent = getTransportTypeIcon(vehicleType);
        return IconComponent ? <IconComponent width='24px' height='24px' /> : null;
    };

    const renderTemperatureIcon = (TemperatureType) => {
        switch (TemperatureType) {
            case '64f84458304b954cfda030c7':
                return <TemperatureIcon type={3} width='24px' height='24px' />;
            case '64f8444f304b954cfda030c6':
                return <TemperatureIcon type={3} width='24px' height='24px' />;
            case null:
                return <TemperatureIcon width='24px' height='24px' />;
            default:
                return <TemperatureIcon type={2} width='24px' height='24px' />;
        }
    };

    const renderCategoryIcon = (category) => {
        switch (category) {
            case 'paper':
                return <DocumentIconNew width='24px' height='24px' />;
            case 'confectionery':
                return <ConfectioneryIcon width='24px' height='24px' />;
            case 'furniture':
                return <FurnitureIcon width='24px' height='24px' />;
            case 'metal':
                return <MetalIcon width='24px' height='24px' />;
            case 'metal_cans':
                return <MetalCansIcon width='24px' height='24px' />;
            case 'beverages':
                return <BeveragesIcon width='24px' height='24px' />;
            case 'equipment':
                return <EquipmentIcon width='24px' height='24px' />;
            case 'food':
                return <FoodIcon width='24px' height='24px' />;
            case 'glassProducts':
                return <GlassProductsIcon width='24px' height='24px' />;
            case 'constructionMaterials':
                return <ConstructionMaterialsIcon width='24px' height='24px' />;
            case 'tobacco':
                return <TobaccoIcon width='24px' height='24px' />;
            case 'pharmaceuticals':
                return <PharmaceuticalsIcon width='24px' height='24px' />;
            case 'alcohol':
                return <AlcoholIcon width='24px' height='24px' />;
            case 'fertilize':
                return <FertilizeIcon width='24px' height='24px' />;
            default:
                return <BoxIcon type={2} width='24px' height='24px' />;
        }
    };

    return (
        <div className={cn(style.cargo_wrapper)}>
            <div className={cn(style.cargo_title, style.orders_title)}>{t('orderInfo.ordersInfoCargo.title')}</div>
            <div className={cn(style.cargo_content, { [style.cargo_content_railway]: isRailway })}>
                <div className={style.cargo_details}>
                    {renderCategoryIcon(item?.category)} {item?.categoryName}
                </div>
                <div className={cn(style.cargo_details, { [style.cargo_railwayDetail]: isRailway })}>
                    {isRailway ? (
                        <>
                            <WagonTypeIcon />
                            <div className={style.cargo_category}>{t("railwayOrder.wagonType")}:</div>
                            <span className={style.cargo_railwayValue}>{item?.wagonTypeName || "—"}</span>
                        </>
                    ) : (
                        <>{renderVehicleIcon(item?.vehicleType)} {getVehicleTypeName(item, t)}</>
                    )}
                </div>
                <div className={style.cargo_details}>
                    <ScalesIcon width='24px' height='24px' /> <div className={style.cargo_category}>{t('orderInfo.ordersInfoCargo.massLabel')}</div> {item?.weight} {item?.unitMeasurement == "Kg" ? t("orderInfo.ordersInfoCargo.kgUnit") : t("orderInfo.ordersInfoCargo.tonsUnit")}
                </div>
                <div className={style.cargo_details}>
                    {renderTemperatureIcon(item?.temperature)} {item?.temperature || t('orderInfo.ordersInfoCargo.noTemperature')}
                </div>
                {item?.volume != null && (
                    <div className={style.cargo_details}>
                        <BoxIcon width='24px' height='24px' /> <div className={style.cargo_category}>{t('orderInfo.ordersInfoCargo.dimensionsLabel')}</div> {item?.volume} {t('ordersCreateDesktop.detailsSection.volumeUnit')}³
                    </div>
                )}
                {item?.pallet != null && (
                    <div className={style.cargo_details}>
                        <PalletIcon />
                        <div className={style.cargo_category}>{t("orderInfo.ordersInfoCargo.pallets")}</div>
                        {item?.pallet}
                    </div>
                )}
                {tnvedCode != null && (
                    <div className={style.cargo_details}>
                        <BarcodeIcon />
                        <div className={style.cargo_category}>{t("orderInfo.ordersInfoCargo.hsCode")}:</div>
                        {tnvedCode}
                    </div>
                )}
                {isRailway && order?.etsngCode && (
                    <div className={cn(style.cargo_details, style.cargo_railwayDetail)}>
                        <EtsngCodeIcon />
                        <div className={style.cargo_category}>{t("railwayOrder.etsngCode")}:</div>
                        <span className={style.cargo_railwayValue}>{order.etsngCode}</span>
                    </div>
                )}
                {isRailway && order?.gngCode && (
                    <div className={cn(style.cargo_details, style.cargo_railwayDetail)}>
                        <GngCodeIcon />
                        <div className={style.cargo_category}>{t("railwayOrder.gngCode")}:</div>
                        <span className={style.cargo_railwayValue}>{order.gngCode}</span>
                    </div>
                )}
                {isDetails && 
                    <div className={style.cargo_details}>
                        <CommentIcon width='24px' height='24px' fill={"#6D7885"} /> {item?.details}
                    </div>
                }
                {order?.incoterms && (
                    <div className={style.cargo_details}>
                        <PolicyIcon fill="#6D7885" />
                        <div className={style.cargo_category}>{t("orderInfo.ordersInfoCargo.deliveryTerms")}:</div>
                        {order.incoterms}
                    </div>
                )}
                {isRailway && <CargoWagonNumbers key={order?.id} order={order} />}
            </div>
        </div>
    );
};

export default OrdersInfoCargo;
